import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as tracks from '@webapp/sdk/tracks';
import { Action } from 'redux';
import { CREATE_TRACK } from '../actions';
import { CreateTrack, CreateTrackSuccess, CreateTrackError } from '../action-creators';
import AppState from '../../state';
import SimpleTrack from '@common/types/release/simple-track';


export const createTrackEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, CreateTrack>(CREATE_TRACK),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {

        const track: Partial<SimpleTrack> = {
          ...state.tracks.tracks[action.trackId],
          releaseId: action.releaseId
        };

        const draft = await tracks.create(track)
        
        return new CreateTrackSuccess(draft);
      } catch (err) {
        return new CreateTrackError(err.message)
      }
    })
  );